
import SvgIcon from "@material-ui/core/SvgIcon"
import { ReactComponent as GoogleIcon } from "../fontello/icons/svg/ic_google.svg"


const Google = ({ ...props }) => (
  <SvgIcon
    component={GoogleIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Google
